// extracted by mini-css-extract-plugin
export default {"option":"buinK","option__platform-top":"oHRqV","option__description":"nNcsj","option__title":"RUyaS","option__sprite":"oMnQL"};